module.exports = __webpack_public_path__ + "img/3a99f12.jpg";